<template>
  <b-modal
    ref="modal"
    hide-footer
    title="Thêm mới sản phẩm con"
    :visible="isVisible"
    @hidden="onHidden"
    id="modal-prevent-closing"
    class="child-product-modal"
  >
    <v-form ref="form" lazy-validation>
      <div class="row">
        <!-- Left Column -->
        <div class="col-md-6">
          <div class="form-section">
            <div class="mb-3">
              <label class="form-label">Mã vạch sản phẩm:</label>
              <b-form-input
                size="sm"
                type="text"
                v-model="localBarcode"
                placeholder="Nhập mã vạch sản phẩm"
                @input="updateValue('barcode')"
                class="form-input"
              ></b-form-input>
            </div>
            <!-- Dynamic Product Options -->
            <div v-if="productOptions && productOptions.length > 0">
              <div
                v-for="(option, optionIndex) in productOptions"
                :key="optionIndex"
                class="mb-3"
              >
                <label class="form-label">{{ option.name }}:</label>
                <select
                  class="form-control form-control-sm form-input"
                  :id="`option-select-${optionIndex}`"
                  v-model="selectedValues[String(optionIndex)]"
                  @change="handleOptionChange(optionIndex, $event.target.value)"
                >
                  <option value="" disabled>
                    {{ `-- Chọn ${option.name} --` }}
                  </option>
                  <option
                    v-for="(value, valueIndex) in (option.values || option.optionValues)"
                    :key="valueIndex"
                    :value="value"
                  >
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>

            <p v-else class="text-muted">
              Không có thuộc tính sản phẩm. Vui lòng thêm thuộc tính sản phẩm
              trước.
            </p>
          </div>
        </div>

        <!-- Right Column -->
        <div class="col-md-6">
          <div class="form-section">
            <div class="mb-3">
              <label class="form-label">Giá nhập:</label>
              <b-form-input
                size="sm"
                v-model="localOriginalPrice"
                placeholder="Nhập giá nhập"
                class="text-right form-input"
                v-mask="mask"
                @input="updateValue('originalPrice')"
              ></b-form-input>
            </div>

            <div class="mb-3">
              <label class="form-label">Giá bán:</label>
              <b-form-input
                size="sm"
                v-model="localSalePrice"
                required
                placeholder="Nhập giá bán"
                type="text"
                class="text-right form-input"
                v-mask="mask"
                @input="updateValue('salePrice')"
              ></b-form-input>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="mt-4 d-flex justify-content-start">
        <b-button
          class="btn-action mr-2"
          variant="primary"
          size="sm"
          @click="saveChildProduct"
          >Lưu</b-button
        >
        <b-button
          class="btn-action"
          variant="secondary"
          size="sm"
          @click="cancel"
          >Hủy</b-button
        >
      </div>
    </v-form>
  </b-modal>
</template>

<script>
import { currencyMask } from '@/utils/common';

export default {
  name: 'ChildProductModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    barcode: {
      type: String,
      default: '',
    },
    originalPrice: {
      type: [String, Number],
      default: 0,
    },
    salePrice: {
      type: [String, Number],
      default: 0,
    },
    productOptions: {
      type: Array,
      default: () => [],
    },
    initialSelectedOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isVisible: this.value,
      localBarcode: this.barcode,
      localOriginalPrice: this.originalPrice,
      localSalePrice: this.salePrice,
      selectedValues: {},
      mask: currencyMask,
    };
  },
  created() {
    this.initializeComponent();
  },
  watch: {
    value(newVal, oldVal) {
      this.isVisible = newVal;
      if (newVal && !oldVal) {
        this.initializeComponent();
      }
    },
    barcode(val) {
      this.localBarcode = val;
    },
    originalPrice(val) {
      this.localOriginalPrice = val;
    },
    salePrice(val) {
      this.localSalePrice = val;
    },
    initialSelectedOptions: {
      handler() {
        this.initializeSelectedValues();
      },
      deep: true,
    },
  },
  methods: {
    initializeComponent() {
      this.localBarcode = this.barcode;
      this.localOriginalPrice = this.originalPrice;
      this.localSalePrice = this.salePrice;

      this.initializeSelectedValues();
    },

    initializeSelectedValues() {
      this.selectedValues = {};

      if (this.productOptions && this.productOptions.length > 0) {
        this.productOptions.forEach((_, index) => {
          const key = String(index);
          let value = '';
          
          if (this.initialSelectedOptions && this.initialSelectedOptions[key]) {
            value = this.initialSelectedOptions[key];
          }
          
          this.$set(this.selectedValues, key, value);
        });
      }
    },

    handleOptionChange(optionIndex, value) {
      this.$emit('option-selected', {
        optionId: String(optionIndex),
        optionName: this.productOptions[optionIndex].name,
        value: value === '' ? null : value,
      });
    },

    show() {
      this.isVisible = true;
    },

    hide() {
      this.isVisible = false;
    },

    onHidden() {
      this.$emit('input', false);
    },

    cancel() {
      this.hide();
      this.$emit('cancel');
    },

    updateValue(key) {
      switch (key) {
        case 'barcode':
          this.$emit('update:barcode', this.localBarcode);
          break;
        case 'originalPrice':
          this.$emit('update:originalPrice', this.localOriginalPrice);
          break;
        case 'salePrice':
          this.$emit('update:salePrice', this.localSalePrice);
          break;
      }
    },

    saveChildProduct() {
      let allSelected = true;
      const missingOptions = [];

      if (this.productOptions && this.productOptions.length > 0) {
        this.productOptions.forEach((option, index) => {
          const key = String(index);
          const value = this.selectedValues[key];
          if (!value || value === '') {
            allSelected = false;
            missingOptions.push(option.name);
          }
        });
      }

      if (!allSelected) {
        this.$swal.fire({
          title: 'Lỗi',
          text: `Vui lòng chọn đầy đủ thuộc tính sản phẩm: ${missingOptions.join(
            ', ',
          )}`,
          icon: 'error',
          confirmButtonText: 'Đóng',
        });
        return;
      }

      const selectedOptionsByName = {};
      Object.keys(this.selectedValues).forEach((index) => {
        const optionIndex = parseInt(index);
        const option = this.productOptions[optionIndex];
        if (option && this.selectedValues[index]) {
          selectedOptionsByName[option.name] = this.selectedValues[index];
        }
      });


      this.$emit('save', {
        barcode: this.localBarcode,
        originalPrice: this.localOriginalPrice,
        salePrice: this.localSalePrice,
        selectedOptions: { ...this.selectedValues },
        selectedOptionsByName: selectedOptionsByName,
      });

      this.hide();
    },
  },
};
</script>

<style scoped>
.child-product-modal .modal-body {
  padding: 1.5rem;
}

.form-section {
  margin-bottom: 0.5rem;
}

.section-title {
  font-weight: 600;
  color: #464e5f;
  font-size: 0.95rem;
  margin-top: 0;
}

.form-label {
  font-weight: 500;
  font-size: 0.85rem;
  color: #464e5f;
  margin-bottom: 0.3rem;
  display: block;
}

.form-control,
.custom-select {
  font-size: 0.875rem;
  border-color: #e4e6ef;
}

.form-input {
  height: 31px !important;
  padding: 0.25rem 0.5rem;
  line-height: 1.5;
}

.form-control:focus {
  border-color: #7e8299;
  box-shadow: none;
}

.btn-action {
  min-width: 70px;
  font-weight: 600;
}

@media (min-width: 768px) {
  .col-md-6 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .row {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }
}

@media (max-width: 767.98px) {
  .col-md-6 + .col-md-6 {
    margin-top: 1rem;
  }
}
</style>
